import { render, staticRenderFns } from "./SendMailDialog.vue?vue&type=template&id=09f5fd85&"
import script from "./SendMailDialog.vue?vue&type=script&lang=js&"
export * from "./SendMailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports